import { BlogDetail } from '@/components/blog/BlogDetail';
import { IBlogDetail } from '@/interfaces/IBlogData';
import blogService from '@/libs/services/blogService';
import { GetServerSideProps } from 'next';
import React from 'react'

type props = {
    blogDetail: IBlogDetail
}
const BlogDetailPage = ({ blogDetail }: props) => {
    return (
        <BlogDetail blogDetail={blogDetail}/>
    )
}
export const getServerSideProps: GetServerSideProps = async (context) => {
    const blogSlug = context.query.blogdetail?.toString() || ''
    const blogDetail = await blogService.getBlogDetail(blogSlug);
    if (!blogDetail)
        return {
            notFound: true
        }
    return {
        props: {
            blogDetail: blogDetail[0]
        }
    };
};
export default BlogDetailPage